function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "className", "disabled", "href", "iconEmphasis", "iconRight", "iconSize", "iconSprite", "id", "image", "inline", "isExternal", "layout", "messages", "navigation", "noExternalIcon", "padded", "routerComponent", "routerHrefAttribute", "selected"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Icon } from '@els/els-react--icon';
import { createEnum, ValidPropTypes, makeErrorBoundComponent } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';
var DefaultMessages = createEnum({
  newWindow: '(opens in a new window)'
});
var LinkPadding = createEnum(['one-of-two']);
var bool = PT.bool,
  node = PT.node,
  object = PT.object,
  oneOf = PT.oneOf,
  string = PT.string;
var LinkElement = function LinkElement(props) {
  var children = props.children,
    className = props.className,
    disabled = props.disabled,
    href = props.href,
    iconEmphasis = props.iconEmphasis,
    iconRight = props.iconRight,
    iconSize = props.iconSize,
    iconSprite = props.iconSprite,
    id = props.id,
    image = props.image,
    inline = props.inline,
    isExternal = props.isExternal,
    layout = props.layout,
    messages = props.messages,
    navigation = props.navigation,
    noExternalIcon = props.noExternalIcon,
    padded = props.padded,
    routerComponent = props.routerComponent,
    routerHrefAttribute = props.routerHrefAttribute,
    selected = props.selected,
    anchorProps = _objectWithoutProperties(props, _excluded);
  var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
  var showExternalIcon = isExternal && !noExternalIcon;
  var calculatedIconSprite = iconSprite || (showExternalIcon ? "UpRight" : null);
  var calculatedIconRight = iconRight || showExternalIcon && !iconSprite;
  var calculatedIconSize = showExternalIcon && !iconSprite ? "xs" : iconSize;
  var classes = classnames("c-els-link", className, {
    "c-els-link--with-icon-emphasis": iconEmphasis,
    "c-els-link--with-icon-right": calculatedIconRight,
    "c-els-link--with-icon": calculatedIconSprite,
    "c-els-link--image": image,
    "c-els-link--inline": inline,
    "c-els-link--navigation": navigation,
    "c-els-link--selected": selected,
    "c-els-link--vertical": layout === "vertical",
    "c-els-link--padded-1o2": padded === LinkPadding.ONE_OF_TWO,
    "c-els-link--disabled": disabled
  });
  var sharedProps = {
    className: classes,
    // Allow testid to be set to ease testing of large link collections
    "data-testid": id || "link",
    id: id,
    target: isExternal ? "_blank" : null,
    rel: isExternal ? "noopener noreferrer" : null,
    "aria-disabled": disabled ? true : null
  };
  var routerComponentHref = _defineProperty({}, routerHrefAttribute, href);
  var childrenForDisplay = isExternal ? /* @__PURE__ */React.createElement(React.Fragment, null, children, /* @__PURE__ */React.createElement("span", {
    className: "u-els-hide-visually"
  }, " ", compiledMessages.NEW_WINDOW)) : children;
  var linkContent = calculatedIconSprite || padded ? /* @__PURE__ */React.createElement(React.Fragment, null, calculatedIconRight && /* @__PURE__ */React.createElement("span", {
    className: "c-els-link__text"
  }, childrenForDisplay), calculatedIconSprite && /* @__PURE__ */React.createElement(Icon, {
    sprite: calculatedIconSprite,
    isDecorative: true,
    size: calculatedIconSize,
    textAlignment: "offset",
    fallback: (/* istanbul ignore next */
    function fallback() {
      return "";
    })
  }), !calculatedIconRight && /* @__PURE__ */React.createElement("span", {
    className: "c-els-link__text"
  }, childrenForDisplay)) : childrenForDisplay;
  return routerComponent ? /* @__PURE__ */React.createElement(props.routerComponent, _objectSpread(_objectSpread(_objectSpread({}, sharedProps), anchorProps), routerComponentHref), linkContent) : /* @__PURE__ */React.createElement("a", _objectSpread(_objectSpread(_objectSpread({}, sharedProps), anchorProps), {}, {
    href: href
  }), linkContent);
};
LinkElement.propTypes = {
  /** Link content */
  children: node.isRequired,
  /** class name to apply application classes */
  className: string,
  /** Disable the link */
  disabled: bool,
  /** destination for the link */
  href: string.isRequired,
  /** Icon is also blue, for a more obvious link */
  iconEmphasis: bool,
  /** Show Icon to right of link text */
  iconRight: bool,
  /** Size of icon */
  iconSize: string,
  /** Show Icon sprite */
  iconSprite: string,
  /** ID for instance */
  id: string,
  /** Suppress underline for images */
  image: bool,
  /** Is an inline links, shown alongside other text */
  inline: bool,
  /** Open link in a new window */
  isExternal: bool,
  /** Layout of the link */
  layout: string,
  /** Messages for internationalization */
  messages: object,
  /** Is used within navigation, thus not blue */
  navigation: bool,
  /** Suppress the default external icon */
  noExternalIcon: bool,
  /** Link component if router being used */
  padded: oneOf(LinkPadding.getAll()),
  /** Link component if router being used */
  routerComponent: object,
  /** attribute to contain the href, may be 'to' when React Router Link is used for example */
  routerHrefAttribute: string,
  /** Highlight the selected/active link in a navigation */
  selected: bool
};
LinkElement.requiredProps = {
  children: ValidPropTypes.NODE,
  href: ValidPropTypes.STRING
};
LinkElement.defaultProps = {
  className: "",
  disabled: false,
  routerHrefAttribute: "to",
  iconEmphasis: false,
  iconRight: false,
  iconSize: "s",
  iconSprite: null,
  id: null,
  image: false,
  inline: false,
  isExternal: false,
  layout: null,
  messages: DefaultMessages,
  navigation: false,
  noExternalIcon: false,
  padded: null,
  routerComponent: null,
  selected: false
};
LinkElement.DefaultMessages = DefaultMessages;
LinkElement.Padding = LinkPadding;
var RawLinkElement = LinkElement;
var LinkElement$1 = makeErrorBoundComponent(RawLinkElement);
export { LinkElement$1 as LinkElement, RawLinkElement };
